// サイドバーの時の背景色位置調整
// ==========================
function setPositionBg() {
  const targets = document.querySelectorAll('.js-hasBg');
  if (targets.length === 0) return;

  targets.forEach((target) => {
    const leftPosition = target.getBoundingClientRect().left;
    target.style.setProperty('--bg-position', leftPosition);
  });

  //リサイズ処理
  window.addEventListener('resize', () => {
    targets.forEach((target) => {
      const leftPosition = target.getBoundingClientRect().left;
      target.style.setProperty('--bg-position', leftPosition);
    });
  });
}

export { setPositionBg };
